import "./News.css";

export default function News() {
  return (
    <div className="newsContainer">
      <header className="newsHeader">
        <h1>Recent News</h1>
        {/* Update this tag whenever the notice changes */}
        <span className="newsHeaderTag">Posted June 2026</span>
      </header>

      <div className="newsContent">

        {/* Default card: blue left border (newsCard only) */}
        <section className="newsCard">
          <h2 className="newsCardTitle">Upgrading from v3</h2>
          <p>
            CommandPanels v4 is a full rewrite. Panels and configuration files from v3 will
            not work in v4. This was an intentional decision, v3 was never architected well
            for the scope it grew into.
          </p>
          <p>
            Maintaining it meant constant regressions, and that wasn't sustainable.
            v4 was created with a clear goal from the beginning: simpler, more stable,
            and easier to extend.
          </p>
        </section>

        {/* Highlighted card: yellow left border + yellow title (add newsCardHighlight + newsCardTitleHighlight) */}
        <section className="newsCard newsCardHighlight">
          <h2 className="newsCardTitle newsCardTitleHighlight">Use the v3 to v4 Converter (Beta)</h2>
          <p>
            Open the{" "}
            <a
              href="/assets/commandpanels-v3-to-v4-converter.html"
              target="_blank"
              rel="noopener noreferrer"
              className="newsLink"
            >
              Web Converter
            </a>
            , and paste your v3 panels to convert. The converted panels will save you a lot of time and a list of warnings will be provided to assist.
          </p>
          <p>
            Alternatively, you can start fresh by running <code>/pa generate</code> on a chest
            in-game, then building out from there using the Web Editor.
          </p>
        </section>

      </div>
    </div>
  );
}
